import React, {PropTypes} from 'react';

import * as permissions from '../../common/userPermissions';

const UserPermissionRow = ({
  onTogglePermission,
  subscription,
  supportsCareSheet
}) => {
  const {accessCareSheets, accessLabels, manageArticles, manageLogo, manageCareSheetAds} = subscription.permissions;
  return (
    <tr key={subscription.id}>
      <td>{subscription.name}</td>
      {supportsCareSheet && 
      <td className={accessCareSheets ? '' : 'empty'}
          onClick={() => {onTogglePermission(subscription.id, permissions.ACCESS_CARE_SHEETS);}}>
            {accessCareSheets && <i className="fa fa-check fa-lg" />}</td> }
      <td className={accessLabels ? '' : 'empty'}
          onClick={() => {onTogglePermission(subscription.id, permissions.ACCESS_LABELS);}}>
            {accessLabels && <i className="fa fa-check fa-lg" />}</td>
      {supportsCareSheet && 
      <td className={manageCareSheetAds ? '' : 'empty'}
          onClick={() => {onTogglePermission(subscription.id, permissions.MANAGE_CARE_SHEET_ADS);}}>
            {manageCareSheetAds && <i className="fa fa-check fa-lg" />}</td>}
      {supportsCareSheet && 
      <td className={manageLogo ? '' : 'empty'}
          onClick={() => {onTogglePermission(subscription.id, permissions.MANAGE_LOGO);}}>
            {manageLogo && <i className="fa fa-check fa-lg" />}</td> }
      <td className={manageArticles ? '' : 'empty'}
          onClick={() => {onTogglePermission(subscription.id, permissions.MANAGE_ARTICLES);}}>
            {manageArticles && <i className="fa fa-check fa-lg" />}</td>
            
    </tr>
  );
};

UserPermissionRow.propTypes = {
  onTogglePermission: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  supportsCareSheet: PropTypes.bool.isRequired
};

export default UserPermissionRow;


/** WEBPACK FOOTER **
 ** ./src/modules/users/components/UserPermissionRow.js
 **/